// Shared scale helpers for psychometric tests - English version

// Helper for STAI Direct Scoring (1-4)
export const staiDirect = [
  {label: 'Almost never', value: 1},
  {label: 'Sometimes', value: 2},
  {label: 'Often', value: 3},
  {label: 'Almost always', value: 4}
];

// Helper for STAI Reverse Scoring (4-1)
export const staiReverse = [
  {label: 'Almost never', value: 4},
  {label: 'Sometimes', value: 3},
  {label: 'Often', value: 2},
  {label: 'Almost always', value: 1}
];

// Helper for YMRS Normal (0-4)
export const ymrsNormal = [
  {label: 'Absent', value: 0},
  {label: 'Mild', value: 1},
  {label: 'Moderate', value: 2},
  {label: 'Marked', value: 3},
  {label: 'Severe', value: 4}
];

// Helper for YMRS Double Weight (0-8)
export const ymrsDouble = [
  {label: 'Absent', value: 0},
  {label: 'Mild', value: 2},
  {label: 'Moderate', value: 4},
  {label: 'Marked', value: 6},
  {label: 'Severe', value: 8}
];

// Helper for BSSI (0-2)
export const bssiScale = (opt0: string, opt1: string, opt2: string) => [
  {label: opt0, value: 0},
  {label: opt1, value: 1},
  {label: opt2, value: 2}
];

// Generic Likert scales
export const likert0to3 = [
  {label: 'Not at all', value: 0},
  {label: 'Several days', value: 1},
  {label: 'More than half the days', value: 2},
  {label: 'Nearly every day', value: 3}
];

export const likert0to4 = [
  {label: 'Not at all', value: 0},
  {label: 'Slightly', value: 1},
  {label: 'Moderately', value: 2},
  {label: 'Severely', value: 3},
  {label: 'Extremely', value: 4}
];
